import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import * as authActions from '../../Redux/Auth/AuthActions';
import Layout from '../../Utils/Navbar/navbar-layout-component.js';
import Footer from '../../Utils/Footer/footer-component.js';
import VideoComponent from '../../Utils/Video/video-component.js';
import AuthForm from '../../Utils/Auth/auth-form-component.js';
import { ButtonWhite } from '../../Utils/Buttons/button-component.js';
import { ASSETS } from '../../Public/assets-data.js';
import { getLoginData } from '../../Public/login-data.js';
import MediaComponent from '../../Utils/Media/media-component.js';

function Login() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isAuthenticated, currentRoute } = useSelector((s) => s.auth);
    const { language = 'en', dir } = useSelector((s) => s.systemData || {});
    const txt = getLoginData(language);

    const [mode, setMode] = useState('login'); // 'login' | 'register'

    useEffect(() => {
        dispatch(authActions.isLoggedIn());
    }, [dispatch]);

    if (isAuthenticated) {
        const role = localStorage.getItem('role');
        if (role !== 'user') return <Navigate to="/admin" replace />;
        // Only redirect back to guarded user routes; everything else goes to /account
        const PRIVATE_USER_ROUTES = ['/home', '/account'];
        const safeRoute = PRIVATE_USER_ROUTES.includes(currentRoute) ? currentRoute : '/account';
        return <Navigate to={safeRoute} replace />;
    }

    return (
        <div className="flex flex-col min-h-screen">
            <Layout>
                <div dir={dir} className="w-full lg:h-[calc(100vh-80px)] flex flex-col lg:flex-row-reverse overflow-hidden">

                    {/* Video side */}
                    <div className="relative w-full h-[300px] lg:h-full lg:w-1/2 overflow-hidden">
                        <MediaComponent
                            video={"/placeholder.svg"}
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-black/10 lg:bg-transparent" />
                    </div>

                    {/* Form side */}
                    <div className="w-full lg:w-1/2 flex items-center justify-center p-8 sm:p-12 lg:p-20 overflow-y-auto bg-white">
                        <div className="w-full max-w-[400px] mx-auto">
                            <AuthForm
                                mode={mode}
                                onModeChange={setMode}
                            />

                            <div className="mt-6  mx-auto  sm:max-w-[400px] max-w-[304px]">
                                <ButtonWhite
                                    onClick={() => navigate('/')}
                                    fullWidth
                                    size="sm"
                                    icon={
                                        <svg className={`mx-2 w-5 h-5 ${dir === 'rtl' ? 'rotate-180' : ''}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
                                        </svg>
                                    }
                                >
                                    {txt.backBtn}
                                </ButtonWhite>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
            <Footer />
        </div>
    );
}

export default Login;
